import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import SharedPopUp from "@componentsShared/BottomSheetPopup__OLD/SharedPopUp";
import stl from "./AdSection.module.css";
import { useLang } from "@/common/Contexts/LanguageContext";
var AdSection = function AdSection() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var lang = useLang();
  var _useState = useState(false),
    ShowPopUp = _useState[0],
    setShowPopUp = _useState[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.outterContainer,
    id: "renewal-section-container"
  }, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, /*#__PURE__*/React.createElement("h3", {
    id: "renewal-section-title"
  }, t("نجدد سياراتنا ونجهزها حسب الحاجة ", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.imgsContainer,
    id: "renewal-images-container"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: stl.spacer
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.singleImgContainerAD
  }, /*#__PURE__*/React.createElement("img", {
    className: stl.bbAd,
    src: CDN_LINK + "/assets/images/WashAndPolish.webp",
    alt: "image",
    loading: "lazy",
    width: "255px",
    height: "298px"
  }), lang === "ar" ? /*#__PURE__*/React.createElement("img", {
    "data-dis": "ar",
    className: stl.whiteAd,
    src: CDN_LINK + "/assets/images/WashAndPolishAr.svg",
    alt: "image",
    loading: "lazy",
    width: "148px",
    height: "75px"
  }) : /*#__PURE__*/React.createElement("img", {
    "data-dis": "en",
    className: stl.whiteAd,
    src: CDN_LINK + "/assets/images/WashAndPolishEn.svg",
    alt: "image",
    loading: "lazy",
    width: "148px",
    height: "75px"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.singleImgContainerAD
  }, /*#__PURE__*/React.createElement("img", {
    className: stl.bbAd,
    src: CDN_LINK + "/assets/images/PaintInspection.webp",
    alt: "image",
    loading: "lazy",
    width: "255px",
    height: "298px"
  }), lang === "ar" ? /*#__PURE__*/React.createElement("img", {
    "data-dis": "ar",
    className: stl.whiteAd,
    src: CDN_LINK + "/assets/images/PaintInspectionAr.svg",
    alt: "image",
    loading: "lazy",
    width: "148px",
    height: "75px"
  }) : /*#__PURE__*/React.createElement("img", {
    "data-dis": "en",
    className: stl.whiteAd,
    src: CDN_LINK + "/assets/images/PaintInspectionEn.svg",
    alt: "image",
    loading: "lazy",
    width: "148px",
    height: "75px"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.singleImgContainerAD
  }, /*#__PURE__*/React.createElement("img", {
    className: stl.bbAd,
    src: CDN_LINK + "/assets/images/PartsReplacement.webp",
    alt: "image",
    loading: "lazy",
    width: "255px",
    height: "298px"
  }), lang === "ar" ? /*#__PURE__*/React.createElement("img", {
    "data-dis": "ar",
    className: stl.whiteAd,
    src: CDN_LINK + "/assets/images/PartsReplacementAr.svg",
    alt: "image",
    loading: "lazy",
    width: "148px",
    height: "75px"
  }) : /*#__PURE__*/React.createElement("img", {
    "data-dis": "en",
    className: stl.whiteAd,
    src: CDN_LINK + "/assets/images/PartsReplacementEn.svg",
    alt: "image",
    loading: "lazy",
    width: "148px",
    height: "75px"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.spacer
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.btnCont
  }, /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      setShowPopUp(true);
    },
    id: "disclaimer-button"
  }, t("إخلاء مسؤولية", {
    ns: "web_post_view"
  }))))), /*#__PURE__*/React.createElement(SharedPopUp, {
    show: ShowPopUp,
    onClose: function onClose() {
      setShowPopUp(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.ms2olyenPopUpCR
  }, /*#__PURE__*/React.createElement("strong", null, t("إخلاء مسؤولية", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("p", null, t("\u064A\u0633\u062A\u0646\u062F \u0647\u0630\u0627 \u0627\u0644\u062A\u0642\u0631\u064A\u0631 \u0625\u0644\u0649 \u062D\u0627\u0644\u0629 \u0627\u0644\u0633\u064A\u0627\u0631\u0629 \u0641\u064A \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0641\u062D\u0635 \u0648\u064A\u0642\u062F\u0645 \u062A\u0642\u062F\u064A\u0631\u064B\u0627\n            \u062A\u0642\u0631\u064A\u0628\u064A\u064B\u0627 \u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u0633\u064A\u0627\u0631\u0629 \u0641\u064A \u0630\u0644\u0643 \u0627\u0644\u062A\u0627\u0631\u064A\u062E. \u0643\u0627\u0646\u062A \u0627\u0644\u0623\u062C\u0632\u0627\u0621 \u0627\u0644\u0645\u0630\u0643\u0648\u0631\u0629 \u0648\n            \u0627\u0644\u0645\u0634\u0627\u0631 \u0625\u0644\u064A\u0647\u0627 \u0641\u064A \u062D\u0627\u0644\u0629 \u0643\u0645\u0627 \u0630\u0643\u0631\u0639\u0646\u0647\u0627 \u0641\u064A \u0627\u0644\u062A\u0642\u0631\u064A\u0631- \u0644\u0627 \u064A\u0623\u062E\u0630 \u0627\u0644\u062A\u0642\u0631\u064A\u0631 \u0641\u064A\n            \u0627\u0644\u0627\u0639\u062A\u0628\u0627\u0631 \u062D\u0627\u0644\u0629 \u0627\u0644\u0623\u062C\u0632\u0627\u0621 \u063A\u064A\u0631 \u0627\u0644\u0645\u0631\u0626\u064A\u0629 \u0623\u0648 \u063A\u064A\u0631 \u0627\u0644\u0645\u0641\u062D\u0648\u0635\u0629 \u0645\u0646 \u0627\u0644\u0633\u064A\u0627\u0631\u0629. \u064A\u0639\u062A\u0645\u062F\n            \u0646\u0638\u0627\u0645 \u0627\u0644\u0641\u062D\u0635 \u0639\u0644\u0649 \u0642\u0631\u0627\u0621\u0629 \u0639\u062F\u0627\u062F \u0627\u0644\u0633\u064A\u0627\u0631\u0629 \u0644\u0644\u0645\u0633\u0627\u0641\u0629 \u0628\u0627\u0644\u0643\u064A\u0644\u0648\u0645\u062A\u0631\u0627\u062A \u0643\u0645\u0627 \u0647\u0648 \u0638\u0627\u0647\u0631\n            \u0641\u064A \u0648\u0642\u062A \u0627\u0644\u0641\u062D\u0635 \u0648\u0644\u064A\u0633 \u0645\u0633\u0624\u0648\u0644\u0627\u064B \u0639\u0646 \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0635\u062D\u062A\u0647.", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("p", null, t("\u0644\u0627 \u064A\u0639\u0646\u064A \u0647\u0630\u0627 \u0627\u0644\u062A\u0642\u0631\u064A\u0631 \u0628\u0623\u064A \u062D\u0627\u0644 \u0645\u0646 \u0627\u0644\u0623\u062D\u0648\u0627\u0644 \u0627\u0644\u0627\u0644\u062A\u0632\u0627\u0645 \u0628\u062D\u0627\u0644\u0629 \u0627\u0644\u0633\u064A\u0627\u0631\u0629 \u0643\u0645\u0627\n              \u0630\u0643\u0631 \u0628\u0627\u0644\u0641\u062D\u0635 \u0641\u062C\u0645\u064A\u0639 \u0627\u0644\u062A\u0642\u0627\u0631\u064A\u0631 \u062A\u0627\u0628\u0639\u0629 \u0644\u0646\u0638\u0627\u0645 \u0645\u062D\u062F\u062F \u0641\u064A \u0641\u062D\u0635 \u0627\u0644\u0633\u064A\u0627\u0631\u0627\u062A \u0648\u0644\u0627 \u064A\u0645\u0643\u0646\n              \u062A\u062D\u0645\u064A\u0644 \u0634\u0631\u0643\u0629 \u0633\u064A\u0627\u0631\u0629 \u0648\u0634\u0631\u0643\u0627\u0626\u0647\u0627 \u0627\u0644\u0645\u0633\u0626\u0648\u0644\u064A\u0629 \u0628\u0623\u064A \u0637\u0631\u064A\u0642\u0629 \u0628\u0633\u0628\u0628 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0647\u0630\u0627\n              \u0627\u0644\u062A\u0642\u0631\u064A\u0631.", {
    ns: "web_post_view"
  })))));
};
export default AdSection;